var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cardUrl)?_c('div',{staticClass:"m-wap-card"},[_c('iframe',{attrs:{"src":_vm.cardUrl,"frameborder":"0"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }